
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"91","height":"69","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"91","height":"69","rx":"7","fill":"#27E96A"}}),_c('path',{attrs:{"d":"M73.33 33.906H68.77A1.912 1.912 0 0166.852 32v-4.54a1.912 1.912 0 00-1.916-1.907h-4.562a1.912 1.912 0 01-1.917-1.907v-4.552a1.912 1.912 0 00-1.916-1.908h-4.562a1.912 1.912 0 01-1.917-1.907v-4.552a1.912 1.912 0 00-1.916-1.907h-5.162a1.912 1.912 0 00-1.917 1.907v4.54a1.912 1.912 0 01-1.916 1.908h-4.562a1.912 1.912 0 00-1.917 1.907v4.54a1.912 1.912 0 01-1.916 1.907h-4.61a1.912 1.912 0 00-1.916 1.908v4.54a1.912 1.912 0 01-1.917 1.907H17.74a1.912 1.912 0 00-1.917 1.907v5.137c0 1.053.858 1.907 1.917 1.907h4.562c1.058 0 1.916.855 1.916 1.908v4.54c0 1.053.858 1.907 1.917 1.907h4.562c1.058 0 1.916.854 1.916 1.907v4.54c0 1.053.859 1.908 1.917 1.908h21.975a1.912 1.912 0 001.917-1.908v-4.54c0-1.053.858-1.907 1.917-1.907H64.9a1.912 1.912 0 001.917-1.907v-4.54c0-1.053.858-1.908 1.917-1.908h4.562a1.912 1.912 0 001.916-1.907V35.79c.035-1.03-.823-1.884-1.881-1.884zM49.44 50.64H35.153a1.912 1.912 0 01-1.916-1.907v-4.54a1.912 1.912 0 00-1.917-1.908h-4.574a1.912 1.912 0 01-1.916-1.907v-3.943c0-1.053.858-1.907 1.916-1.907h4.562a1.912 1.912 0 001.917-1.908v-4.54c0-1.053.858-1.907 1.916-1.907h4.562a1.912 1.912 0 001.917-1.907v-4.576c0-1.053.858-1.907 1.916-1.907H47.5c1.058 0 1.916.854 1.916 1.907v4.54c0 1.054.859 1.908 1.917 1.908h4.585c1.059 0 1.917.854 1.917 1.907v4.54c0 1.053.858 1.907 1.917 1.907h4.562c1.058 0 1.916.855 1.916 1.908v3.943a1.912 1.912 0 01-1.916 1.907H59.75a1.912 1.912 0 00-1.917 1.908v4.563a1.912 1.912 0 01-1.917 1.907H49.44v.012z","fill":"#fff"}})])
          )
        }
      }
    